<template>
  <div class="direction center get_page bgSea">
    <div class="box">
      <div class="top">
        <!-- 翻译注释 -->
        <!-- <img :src="imgs.translate" alt="" /> -->
        <div class="mock-click" @click="showMore = true"></div>
        <img class="more" @click="showMore = true" :src="imgs.more" alt="" />
      </div>
      <div class="editBack" :style="{ 'background-image': `url(${paper})` }">
        <div class="avatar">
          <img :src="avatarUrl" alt="" />
        </div>
        <div class="bottleInfo">
          <div class="infoTop">
            <div class="username">{{ bottleInfo?.user_info?.nickname }}</div>
            <div class="userage" v-if="bottleInfo?.type !== 1">
              <img :src="bottleInfo.gender == 1 ? imgs.men_full : imgs.women_full" alt="" />{{
                bottleInfo?.user_info?.age }}
            </div>
          </div>
          <div class="infoBottom">
            <span v-if="bottleInfo?.type === 3"> {{ formatNation }},</span><span>{{
              calculateTimeDifference(bottleInfo.created_at) }}</span>
          </div>
        </div>
        <div @click="handlePreview(bottleInfo?.config?.url)" v-if="bottleInfo?.config?.url" class="textImg">
          <img @click="handlePreview(bottleInfo?.config?.url)" :src="bottleInfo?.config?.url" alt="" />
        </div>
        <div class="textContent" :style="{ fontFamily: familyType }" v-html="formatText(bottleInfo?.content)"></div>
      </div>
      <div class="bottomText">
        <div class="release" @click="handleRelease" style="margin-right: 0.5rem">
          <img :src="imgs.release" alt="" />Release
        </div>
        <div class="reply" @click="goReply">
          <img :src="imgs.reply" alt="" />Reply
        </div>
      </div>
    </div>
    <van-action-sheet v-model:show="showMore">
      <div class="moreModel">
        <div class="topTip"></div>
        <div class="moreOff" @click="showMore = false">
          <img :src="imgs.off" alt="" />
        </div>
        <div class="moreBtn" @click="Copy()" style="margin-top: 1rem">
          <img :src="imgs.copy" alt="" />Copy
        </div>
        <div class="moreBtn" @click="showDialog1 = true">
          <img :src="imgs.report" alt="" />Report
        </div>
        <div class="moreBtn" @click="showDialog2 = true">
          <img :src="imgs.block" alt="" />Block
        </div>
      </div>
    </van-action-sheet>
    <van-dialog v-model:show="showDialog1" :showConfirmButton="false">
      <div class="SendModel">
        <div class="sendOff" @click="showDialog1 = false">
          <img :src="imgs.off" alt="" />
        </div>
        <img class="sendImg" :src="imgs.report_full" alt="" />
        <div class="sendTitle">Report user</div>
        <div class="sendContext">
          Does this content seem inappropriate?<br />
          Our monitoring team will then process<br />
          to review the content and take<br />
          appropriate action.
        </div>
        <div class="sendBtn" @click="handleReport">Report</div>
      </div>
    </van-dialog>
    <van-dialog v-model:show="showDialog2" :showConfirmButton="false">
      <div class="SendModel">
        <div class="sendOff" @click="showDialog2 = false">
          <img :src="imgs.off" alt="" />
        </div>
        <img class="sendImg" :src="imgs.block_full" alt="" />
        <div class="sendTitle">Block this user</div>
        <div class="sendContext">
          Do you want to block this user? You<br />
          will no longer receive their bottles.
        </div>
        <div class="sendBtn" @click="handelBlock(bottleInfo?.send_id)">
          Block
        </div>
      </div>
    </van-dialog>
    <!-- update username -->
    <van-dialog v-model:show="isUpdateUsernameShow" :showConfirmButton="false">
      <div class="SendModel">
        <div class="sendOff" @click="isUpdateUsernameShow = false">
          <img :src="imgs.off" alt="" />
        </div>
        <div class="sendTitle">Telegram Set Username</div>
        <img class="sendImg update-username-img" src="/imgs/home/updateUsername.jpg" alt=""
          @click="handlePreview('/imgs/home/updateUsername.jpg')" />
        <div class="sendContext">
          1. Enter to the settings tab.<br />
          2. Tap on your account - you will find that your Username is set to
          ‘None‘ by default.<br />
          3. Enter your desired username on the text input box.<br />
        </div>
        <div class="sendBtn" @click="jumpTg">GO TO</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { poolBottleInfo } from '@/config/common/total'
import {
  formatDate,
  fontFamilyList,
  paperList,
  getAvatar,
  calculateTimeDifferenceFn,
  getTgInitData,
} from '@/config/common/dic'
import { showToast, showImagePreview } from 'vant'
const base_url = import.meta.env.VITE_BASE_URL
export default {
  components: {},
  data() {
    return {
      showDialog1: false,
      showDialog2: false,
      showMore: false,
      bottleInfo: {
        userName: 'Weile',
        gender: 0,
        age: 18,
        country: 'Canada',
        time: 'May 12th 2024',
        avatar: '',
      },
      imgs: this.$store.state.sourceMsg,
      url: '',
      formatDateFn: formatDate,
      fontFamilyList: [],
      paperList: [],
      isUpdateUsernameShow: false,
    }
  },
  computed: {
    avatarUrl() {
      return getAvatar(this.bottleInfo?.send_id)
    },
    paper() {
      return (
        this.paperList.find((item) => item.id === this.bottleInfo.config?.paper)
          ?.img || this.$store.state.sourceMsg.paper1
      )
    },
    familyType() {
      return (
        this.fontFamilyList.find(
          (item) => item.id === this.bottleInfo.config?.fontFamily
        )?.fontFamily || this.$store.state.sourceMsg.font1
      )
    },
    formatNation() {
      return this.$g.getCountryName(this.bottleInfo?.user_info?.nation)
    },
  },
  created() {
    if (poolBottleInfo.value?.content) {
      this.bottleInfo = poolBottleInfo.value
      if (!this.bottleInfo?.config) {
        this.bottleInfo.config = { paper: 1, fontFamily: 0, url: '' }
      }
    }
    this.fontFamilyList = fontFamilyList()
    this.paperList = paperList()
  },
  mounted() {
    this.readMessageFn()
  },
  beforeUnmount() { },
  methods: {
    calculateTimeDifference(time) {
      return calculateTimeDifferenceFn(time)
    },
    handlePreview(url) {
      console.log(url, 'url->>>')
      url && showImagePreview([url])
    },
    handleReport() {
      this.$api.reportBottle(this.bottleInfo.id).then((res) => {
        if (res.code === 0) {
          showToast('Release success')
          this.$router.push('/home')
          return
        }
        showToast(res?.message)
      })
    },
    formatText(text = '') {
      // 使用正则表达式替换文本中的 \n 为 <br> 标签
      return text.replace(/\n/g, '<br>')
    },
    Copy() {
      let textToCopy = this.text
      // 将文本内容写入剪贴板
      navigator.clipboard.writeText(textToCopy)
      showToast('Copy text to clipboard')
    },
    goReply() {
      // 在这里做是否有username校验
      const username = getTgInitData('username')
      if (!username) {
        return (this.isUpdateUsernameShow = true)
      }
      this.$router.push('/reply')
    },
    handleRelease() {
      this.$api.poolAgainBottle(this.bottleInfo.id).then((res) => {
        if (res.code === 0) {
          showToast('Release success')
          this.$router.push('/home')
          return
        }
        showToast(res?.message)
      })
    },
    readMessageFn() {
      this.$api.readMessage(this.bottleInfo.id).then((res) => {
        if (res.code === 0) {
          return
        }
      })
    },
    handlePreview(url) {
      console.log(url, 'url->>>')
      url && showImagePreview([url])
    },
    handelBlock(id) {
      this.$api.blockFriend({ target_id: id }).then((res) => {
        if (res.code === 0) {
          showToast('Block success')
          return this.$router.push('/home')
        }
        return showToast(res?.message)
      })
    },
    jumpTg() {
      window.Telegram.WebApp.openTelegramLink('https://t.me/DriftSeaChannel')
    },
  },
}
</script>

<style scoped lang="scss">
.mock-click {
  width: 2rem;
  height: 2rem;
  position: fixed;
  top: 0;
  right: 0;
}

.bgSea {
  background: linear-gradient(to bottom, #acecf9, #d6fdfa);
  height: 31vh;
}

.box {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.top {
  width: 90%;
  margin: 1rem auto;
  margin-bottom: 0;
  display: flex;
  justify-content: end;
  align-items: center;

  img {
    width: 1rem;
    height: 1rem;
  }

  .more {
    margin-left: 0.5rem;
    width: 1rem;
    height: 0.25rem;
  }
}

.bottomText {
  height: 4rem;
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    width: 7.45rem;
    height: 2.35rem;
    font-size: 0.85rem;
    font-weight: bold;
    color: #fff;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-right: 0.3rem;
    }
  }

  .release {
    background-color: #f75d7a;

    img {
      width: 0.65rem;
      height: 0.7rem;
    }
  }

  .reply {
    background-color: #39cce9;

    img {
      width: 0.85rem;
      height: 0.6rem;
    }
  }
}

.editBack {
  width: 17rem;
  height: calc(100% - 4rem - 4rem);
  margin: 0 auto;
  padding-bottom: 0.25rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  justify-content: start;
  position: relative;

  .textImg {
    position: relative;
    width: 200px;
    margin-top: 0.5rem;

    .deleteImg {
      position: absolute;
      top: -1rem;
      right: -1rem;
      width: 2rem;
      height: 2rem;
    }

    img {
      max-width: 2rem;
      max-height: 6.5rem;
      border-radius: 0.5rem;
      object-fit: contain;
    }
  }

  .avatar {
    position: absolute;
    top: -1.8rem;
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;

    img {
      width: 3.3rem;
      height: 3.3rem;
      border-radius: 100%;
      background: url('/imgs/bottleType/drift_sea_logo.jpg');
      background-size: contain;
      z-index: 1;
    }
  }

  .bottleInfo {
    display: flex;
    flex-direction: column;
    margin-top: 2rem;

    .infoTop {
      display: flex;
      justify-content: center;

      .username {
        font-size: 0.5rem;
        width: 4.65rem;
        height: 1rem;
        line-height: 1rem;
        font-weight: bold;
        background: #ffffff;
        border-radius: 0.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .userage {
        display: flex;
        align-items: center;
        font-size: 0.5rem;

        img {
          width: 0.7rem;
          height: 0.7rem;
          margin: 0 0.3rem;
        }
      }
    }

    .infoBottom {
      font-size: 0.5rem;
      margin: 0.5rem 0;

      span {
        margin: 0 0.15rem;
      }
    }
  }

  .textContent {
    font-size: 0.7rem;
    font-weight: bold;
    padding: 0 1rem;
    text-align: start;
    height: 75%;
    overflow: scroll;
    word-break: break-word;
  }
}

.moreModel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  .topTip {
    top: 0.5rem;
    width: 4rem;
    height: 0.3rem;
    margin: 0.5rem auto;
    background-color: #dddddd;
    border-radius: 0.5rem;
  }

  .moreOff {
    z-index: 2005;
    position: absolute;
    right: 0.5rem;
    top: -2.2rem;
    width: 1.7rem;
    height: 1.7rem;
    background-color: #fff;
    border-radius: 100%;

    img {
      width: 1.7rem;
      height: 1.7rem;
    }
  }

  .moreBtn {
    background-color: #39cce9;
    width: 11.6rem;
    height: 2.9rem;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    font-size: 1rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 1rem;
      height: 1rem;
      margin-right: 0.5rem;
    }
  }
}

.SendModel {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  .sendOff {
    z-index: 2005;
    position: absolute;
    right: 0;
    top: -2.2rem;
    width: 1.7rem;
    height: 1.7rem;
    background-color: #fff;
    border-radius: 100%;

    img {
      width: 100%;
    }
  }

  .sendImg {
    width: 4.25rem;
    height: 4.25rem;
  }

  .update-username-img {
    width: 80%;
    height: 9rem;
  }

  .sendTitle {
    color: #010101;
    font-size: 1.1rem;
    font-weight: bold;
    margin: 0.3rem 0;
  }

  .sendContext {
    color: #8698b7;
    font-size: 0.7rem;
    word-break: break-word;
    text-align: justify;
  }

  .sendBtn {
    width: 10rem;
    height: 2.5rem;
    color: white;
    background: #39cce9;
    margin: 0.5rem 0;
    border-radius: 0.5rem;
    line-height: 2.5rem;
    font-size: 0.85rem;
  }
}
</style>
